// extracted by mini-css-extract-plugin
export default {"container":"UnitInfo_container__Ld8gk","infoPod":"UnitInfo_infoPod__OQRq2"};